import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Network, Loader2 } from 'lucide-react';
import ReactFlow, { Background, Controls, MiniMap } from 'reactflow';

const GraphTab = ({ graphData, graphLoading, graphIncludeIndivs, setGraphIncludeIndivs, onRefresh }) => (
  <Card className="border-[#E5E7EB]">
    <CardHeader className="pb-2 flex-row items-center justify-between">
      <CardTitle className="text-sm flex items-center gap-2"><Network className="w-4 h-4 text-[#002FA7]" />Ontology Graph</CardTitle>
      <div className="flex items-center gap-2">
        <Label className="flex items-center gap-1.5 text-xs cursor-pointer">
          <input type="checkbox" checked={graphIncludeIndivs} onChange={(e) => setGraphIncludeIndivs(e.target.checked)} data-testid="graph-toggle-individuals" />
          Include individuals
        </Label>
        <Button variant="outline" size="sm" className="h-7 text-xs" onClick={onRefresh} disabled={graphLoading}>
          {graphLoading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : 'Refresh'}
        </Button>
      </div>
    </CardHeader>
    <CardContent>
      <div style={{ height: '70vh' }} className="border border-[#E5E7EB] rounded-lg bg-white" data-testid="graph-canvas">
        {graphData.nodes.length === 0 && (
          <div className="flex flex-col items-center justify-center h-full text-xs text-[#9CA3AF]">
            <Network className="w-10 h-10 opacity-30 mb-2" />
            No data to visualize yet.
          </div>
        )}
        {graphData.nodes.length > 0 && (
          <ReactFlow nodes={graphData.nodes} edges={graphData.edges} fitView minZoom={0.3} maxZoom={1.8}>
            <Background gap={24} />
            <Controls />
            <MiniMap />
          </ReactFlow>
        )}
      </div>
    </CardContent>
  </Card>
);

export default GraphTab;
